import { render, staticRenderFns } from "./pointManagement.vue?vue&type=template&id=6dbefe4a&scoped=true&"
import script from "./pointManagement.vue?vue&type=script&lang=js&"
export * from "./pointManagement.vue?vue&type=script&lang=js&"
import style0 from "./pointManagement.vue?vue&type=style&index=0&id=6dbefe4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbefe4a",
  null
  
)

export default component.exports